var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("installment-state-box", {
    attrs: { "data-qa": "installment-state-box:Canceled" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              _vm._s(_vm.Resources.YourPledge.InstallmentProgressCanceledTitle)
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }